import React, { useState, useEffect, useMemo } from 'react';
import './i18n/i18n';  // Import i18n configuration
import {
  ChakraProvider,
  Box,
  VStack,
  Grid,
  theme,
  Button,
  Text,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  HStack,
  Badge,
  Icon,
  useToast,
  FormControl,
  FormLabel,
  Select,
  GridItem,
  Spinner,
  Alert,
  AlertIcon,
  Container,
  Flex,
  IconButton,
  Collapse,
  Divider,
  Stat,
  StatLabel,
  StatNumber,
  StatGroup,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useMediaQuery,
  Image,
} from '@chakra-ui/react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { ethers } from 'ethers';
import {
  FaWallet,
  FaDice,
  FaHistory,
  FaChevronLeft,
  FaChevronRight,
  FaExchangeAlt,
  FaPowerOff,
  FaCheck,
  FaTimes
} from 'react-icons/fa';
import SwipeableViews from 'react-swipeable-views';
import LandingPage from './LandingPage';
import { PoolPage } from './PoolPage';
import { config } from './config';
import NativeBitBitWin from './NativeBitBitWin.json';
import ERCABI from './erc20.json';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAppKit, useAppKitAccount, useDisconnect, useAppKitNetwork, useAppKitProvider } from '@reown/appkit/react';
import { mainnet, polygon } from '@reown/appkit/networks';
import DocPage from './components/DocPage';
import LanguageSelector from './components/LanguageSelector';
import { useTranslation } from 'react-i18next';
const POOLS = {
  WETH: {
    name: 'WETH',
    icon: 'https://cryptologos.cc/logos/ethereum-eth-logo.png',
    color: '#627EEA'
  },
  ETH: {
    name: 'ETH',
    icon: 'https://cryptologos.cc/logos/ethereum-eth-logo.png',
    color: '#627EEA'
  },
  USDC: {
    name: 'USDC',
    icon: 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png',
    color: '#2775CA'
  },
  USDT: {
    name: 'USDT',
    icon: 'https://cryptologos.cc/logos/tether-usdt-logo.png',
    color: '#26A17B'
  },
  WBTC: {
    name: 'WBTC',
    icon: 'https://cryptologos.cc/logos/wrapped-bitcoin-wbtc-logo.png',
    color: '#935016'
  },
  POL: {
    name: 'POL',
    icon: 'https://cryptologos.cc/logos/polygon-matic-logo.png',
    color: '#8247E5'
  }
};

const POOLS_ARRAY = Object.entries(POOLS);
const format_date = (timestamp) => {
  const currentTime = new Date('2025-01-23T21:52:53+08:00');
  const localDate = new Date(Number(timestamp));
  
  // Return full date and time format
  return `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, '0')}-${String(localDate.getDate()).padStart(2, '0')} ${String(localDate.getHours()).padStart(2, '0')}:${String(localDate.getMinutes()).padStart(2, '0')}:${String(localDate.getSeconds()).padStart(2, '0')}`;
};

const format_mobile_date = (timestamp) => {
  const currentTime = new Date('2025-01-23T21:52:53+08:00');
  const localDate = new Date(Number(timestamp));
  
  // Check if the draw was done today
  const isToday = localDate.toDateString() === currentTime.toDateString();
  
  if (isToday) {
    // Return only time for today's draws
    return `${String(localDate.getHours()).padStart(2, '0')}:${String(localDate.getMinutes()).padStart(2, '0')}:${String(localDate.getSeconds()).padStart(2, '0')}`;
  } else {
    // Return only date for yesterday and earlier draws
    return `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, '0')}-${String(localDate.getDate()).padStart(2, '0')}`;
  }
}

export const convertW3Data = (data, decimals, displayDecimals) => {
  // console.log('convert', data, decimals, displayDecimals);
  if (data === null || data === void 0) {
    debugger;
  }
  if (decimals >= displayDecimals) {
    decimals = decimals - displayDecimals;
    return Number(data / (10n ** window.BigInt(decimals))) / Math.pow(10, displayDecimals);
  } else {
    return Number(data / (10n ** window.BigInt(decimals)));
  }
}
const convertTokenAmt = (amt, token) => {
  const { decimals, displayDecimals } = token;
  return convertW3Data(amt, decimals, displayDecimals);
}
const parseTokenAmt = (amt, token) => {
  const { decimals, displayDecimals } = token;
  if (decimals >= displayDecimals) {
    return window.BigInt(Math.round(amt * (10 ** displayDecimals))) * (10n ** window.BigInt(decimals - displayDecimals));
  } else {
    return window.BigInt(Math.round(amt * (10 ** displayDecimals))) / (10n ** window.BigInt(displayDecimals - decimals));
  }

}
const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  })
}
function PoolSelector({ chainConfig, selectedPool, onPoolSelect }) {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = isMobile ? 3 : 5;
  const M_POOLS = useMemo(() => {
    return (chainConfig?.pools || []).map(pool => {
      return [pool?.name, {
        ...POOLS[pool?.name],
        ...pool
      }]
    })
  }, [chainConfig])
  const totalPages = Math.ceil(M_POOLS.length / itemsPerPage);

  const handleSwipe = (index) => {
    setCurrentPage(index);
    const poolIndex = index * itemsPerPage;
    if (poolIndex < M_POOLS.length) {
      onPoolSelect(M_POOLS[poolIndex].name);
    }
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const getVisiblePools = () => {
    const pages = [];
    for (let i = 0; i < totalPages; i++) {
      const start = i * itemsPerPage;
      const end = start + itemsPerPage;
      pages.push(M_POOLS.slice(start, end));
    }
    return pages;
  };
  const visiblePools = getVisiblePools();

  return (
    <Box
      p={6}
      borderRadius="xl"
      bg="gray.800"
      borderWidth="1px"
      borderColor="blue.500"
      boxShadow="0 0 20px rgba(66, 153, 225, 0.3)"
      w="100%"
    >
      <VStack spacing={4}>
        <Heading size="md" color="gray.200">Select Pool</Heading>
        <Flex w="100%" align="center">
          <IconButton
            icon={<FaChevronLeft />}
            onClick={handlePrev}
            isDisabled={currentPage === 0}
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.200' }}
            aria-label="Previous pools"
          />
          <Box flex="1" overflow="hidden">
            <SwipeableViews
              index={currentPage}
              onChangeIndex={handleSwipe}
              enableMouseEvents
              resistance
              style={{ padding: '10px 0' }}
            >
              {visiblePools.map((poolGroup, pageIndex) => (
                <Grid
                  key={pageIndex}
                  templateColumns={`repeat(${itemsPerPage}, 1fr)`}
                  gap={4}
                  w="100%"
                >
                  {poolGroup.map(([key, pool]) => (
                    <Button
                      key={key}
                      onClick={() => onPoolSelect(key)}
                      variant={selectedPool === key ? "solid" : "outline"}
                      bg={selectedPool === key ? pool?.color : "transparent"}
                      _hover={{
                        bg: pool?.color,
                        opacity: 0.8,
                        transform: 'translateY(-2px)',
                      }}
                      h={{ base: "60px", md: "80px" }}
                      w="100%"
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      transition="all 0.2s"
                      color="white"
                      borderColor={pool?.color}
                    >
                      <Image 
                        src={pool?.icon} 
                        boxSize={{ base: "24px", md: "32px" }} 
                        mb={1}
                      />
                      <Text 
                        fontSize={{ base: "xs", md: "sm" }}
                        fontWeight="medium"
                      >
                        {pool?.name}
                      </Text>
                    </Button>
                  ))}
                </Grid>
              ))}
            </SwipeableViews>
          </Box>
          <IconButton
            icon={<FaChevronRight />}
            onClick={handleNext}
            isDisabled={currentPage === totalPages - 1}
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.200' }}
            aria-label="Next pools"
          />
        </Flex>
      </VStack>
    </Box>
  );
}

function DrawModal({ isOpen, onClose, onConfirm, pool, balance, walletProvider, account, chainConfig }) {
  const { t } = useTranslation();
  const [numbers, setNumbers] = useState(['7', '12', '24', '31']);
  const [ticketCount, setTicketCount] = useState(10);
  const [leverage, setLeverage] = useState(2);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [txStatus, setTxStatus] = useState(null); // 'success', 'error', or null
  const [txError, setTxError] = useState('');
  const [transactionSteps, setTransactionSteps] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);
  const leverageOptions = [2, 5, 10, 20, 50, 100,1000,10000];

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: pool?.displayDecimals
    }).format(amount);
  };

  const getTotalCost = () => {
    return ticketCount * pool?.ticketPrice;
  };

  const isBalanceInsufficient = () => {
    return getTotalCost() > parseFloat(balance);
  };

  const handleNumberChange = (index, value) => {
    const newNumbers = [...numbers];
    newNumbers[index] = value;
    setNumbers(newNumbers);
  };

  useEffect(() => {
    if (isOpen) {
      //randomize initial numbers
      const randomNumbers = [];
      for (let i = 0; i < 4; i++) {
        const randomNum = Math.floor(Math.random() * 49) + 1;
        randomNumbers.push(randomNum.toString());
      }
      setNumbers(randomNumbers);
      setTicketCount(1);
      setLeverage(2);
      setTxStatus(null);
      setTxError('');
      setShowTransactions(false);
      if (pool?.token) {
        setTransactionSteps([
          { id: 'approve', label: t('dapp.drawModal.approveToken'), status: 'not_started' },
          { id: 'draw', label: t('dapp.drawModal.drawLottery'), status: 'not_started' }
        ]);
      } else {
        setTransactionSteps([]);
      }
    }
  }, [isOpen, pool, t]);

  const ensureAllowance = async (pool, amount) => {
    try {
      const provider = new ethers.BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      let writeContract = new ethers.Contract(
        pool.token,
        ERCABI,
        signer
      );
      let ercContract = new ethers.Contract(
        pool.token,
        ERCABI,
        chainConfig.provider
      );
      
      const allowance = await ercContract.allowance(account, pool.address);
      if (allowance >= amount) {
        return true;
      } else {
        if (pool.zeroAllowance && allowance !== 0) {
          const tx = await writeContract.approve(pool.address, 0);
          await tx.wait();
        }
        const tx = await writeContract.approve(pool.address, amount);
        await tx.wait();
        return true;
      }
    } catch (error) {
      console.error('Approval error:', error);
      throw error;
    }
  };

  const handleDraw = async () => {
    if (!pool || !walletProvider) return;
    
    setIsSubmitting(true);
    setTxError('');
    setShowTransactions(true);
    
    try {
      const provider = new ethers.BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      const contractAddress = pool?.address;
      let contract = new ethers.Contract(
        contractAddress,
        NativeBitBitWin.abi,
        signer
      );

      const memo = numbers.join(',');
      const amount = ticketCount * pool?.ticketPrice;
      const amountWei = parseTokenAmt(amount, pool);
      const timestamp = Date.now();

      // Handle token approval if needed
      if (pool.token) {
        try {
          setTransactionSteps(steps => 
            steps.map(step => step.id === 'approve' ? { ...step, status: 'in_progress' } : step)
          );
          await ensureAllowance(pool, amountWei);
          setTransactionSteps(steps => 
            steps.map(step => step.id === 'approve' ? { ...step, status: 'succeed' } : step)
          );
        } catch (error) {
          setTransactionSteps(steps => 
            steps.map(step => step.id === 'approve' ? { ...step, status: 'failed' } : step)
          );
          throw error;
        }
      }

      // Perform the draw
      try {
        setTransactionSteps(steps => 
          steps.map(step => step.id === 'draw' ? { ...step, status: 'in_progress' } : step)
        );
        const tx = await contract.draw(amountWei, leverage, timestamp, memo, 
          { value: pool.native ? amountWei : 0, gasLimit: 824170 }
        );
        await tx.wait();
        setTransactionSteps(steps => 
          steps.map(step => step.id === 'draw' ? { ...step, status: 'succeed' } : step)
        );
        setTxStatus('success');
        onConfirm({ numbers, ticketCount, leverage, txHash: tx.hash, timestamp });
      } catch (error) {
        setTransactionSteps(steps => 
          steps.map(step => step.id === 'draw' ? { ...step, status: 'failed' } : step)
        );
        throw error;
      }
    } catch (error) {
      console.error('Draw error:', error);
      setTxStatus('error');
      setTxError(error.shortMessage || error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'not_started':
        return <Box w="4" h="4" borderRadius="full" bg="gray.500" />;
      case 'in_progress':
        return <Spinner size="sm" color="blue.400" />;
      case 'succeed':
        return <Box color="green.400"><CheckIcon /></Box>;
      case 'failed':
        return <Box color="red.400"><CloseIcon /></Box>;
      default:
        return null;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'not_started':
        return 'gray.500';
      case 'in_progress':
        return 'blue.400';
      case 'succeed':
        return 'green.400';
      case 'failed':
        return 'red.400';
      default:
        return 'gray.400';
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={isSubmitting ? undefined : onClose}
      closeOnOverlayClick={!isSubmitting}
      closeOnEsc={!isSubmitting}
      isCentered
      size="xl"
      blockScrollOnMount={false}
      touchStartCapture={false}
      touchMoveCapture={false}
    >
      <ModalOverlay />
      <ModalContent bg="gray.800" border="1px" borderColor="blue.500">
        <ModalHeader fontSize={{ base: "lg", md: "xl" }} color="white">{t('dapp.drawModal.title')} - {pool?.name} Pool</ModalHeader>
        <ModalCloseButton
          color="white"
          isDisabled={isSubmitting}
        />
        <ModalBody pb={6}>
          <VStack spacing={6}>
            <Box w="100%">
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.300" mb={2}>{t('dapp.drawModal.selectNumbers')} (1-49):</Text>
              <HStack spacing={2} w="100%">
                {numbers.map((num, index) => (
                  <NumberInput
                    key={index}
                    min={1}
                    max={49}
                    value={num}
                    onChange={(value) => handleNumberChange(index, value)}
                    size={{ base: "sm", md: "md" }}
                  >
                    <NumberInputField
                      bg="gray.700"
                      color="white"
                      fontSize={{ base: "xs", md: "sm" }}
                      borderColor="blue.500"
                      _hover={{ borderColor: "blue.400" }}
                      textAlign="center"
                    />
                    <NumberInputStepper>
                      <NumberIncrementStepper color="gray.300" />
                      <NumberDecrementStepper color="gray.300" />
                    </NumberInputStepper>
                  </NumberInput>
                ))}
              </HStack>
            </Box>

            <Box w="100%">
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.300" mb={2}>{t('dapp.drawModal.ticketCount')}:</Text>
              <Grid templateColumns="repeat(4, 1fr)" gap={4} alignItems="center">
                <GridItem colSpan={3}>
                  <NumberInput
                    min={1}
                    value={ticketCount}
                    onChange={(value) => setTicketCount(parseInt(value) || 1)}
                    size={{ base: "sm", md: "md" }}
                    isInvalid={isBalanceInsufficient()}
                  >
                    <NumberInputField
                      bg="gray.700"
                      color="white"
                      fontSize={{ base: "xs", md: "sm" }}
                      borderColor={isBalanceInsufficient() ? "red.500" : "blue.500"}
                      _hover={{ borderColor: isBalanceInsufficient() ? "red.400" : "blue.400" }}
                    />
                    <NumberInputStepper>
                      <NumberIncrementStepper color="gray.300" />
                      <NumberDecrementStepper color="gray.300" />
                    </NumberInputStepper>
                  </NumberInput>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.300" whiteSpace="nowrap">
                    @ {formatAmount(pool?.ticketPrice)} {pool?.name} {t('dapp.drawModal.each')}
                  </Text>
                </GridItem>
              </Grid>
              {isBalanceInsufficient() && (
                <Text fontSize={{ base: "xs", md: "sm" }} color="red.400" mt={1}>
                  {t('dapp.drawModal.insufficientBalance')}. {t('dapp.drawModal.cost')}: {formatAmount(getTotalCost())} {pool?.symbol}
                </Text>
              )}
            </Box>

            <Box w="100%">
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.300" mb={2}>{t('dapp.drawModal.selectMultiplier')}:</Text>
              <Grid templateColumns="repeat(4, 1fr)" gap={2}>
                {leverageOptions.map((value) => (
                  <Button
                    key={value}
                    onClick={() => setLeverage(value)}
                    variant={leverage === value ? "solid" : "outline"}
                    colorScheme={leverage === value ? "yellow" : "gray"}
                    color={leverage === value ? "black" : "white"}
                    size={{ base: "sm", md: "md" }}
                    _hover={{
                      transform: 'translateY(-2px)',
                      boxShadow: leverage === value ? '0 0 20px rgba(236, 201, 75, 0.3)' : 'none'
                    }}
                  >
                    {value}x
                  </Button>
                ))}
              </Grid>
            </Box>

            <Box
              w="100%"
              p={4}
              borderRadius="xl"
              bg="gray.700"
              borderWidth="1px"
              borderColor="yellow.500"
              boxShadow="0 0 20px rgba(236, 201, 75, 0.2)"
            >
              <VStack spacing={2}>
                <Text fontSize={{ base: "sm", md: "md" }} color="gray.300">{t('dapp.drawModal.potentialWin')}:</Text>
                <Heading
                  fontSize={{ base: "lg", md: "xl" }}
                  bgGradient="linear(to-r, yellow.400, orange.400)"
                  bgClip="text"
                >
                  {formatAmount((pool?.ticketPrice * leverage * ticketCount))} {pool?.symbol}
                </Heading>
                <HStack>
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.400">{t('dapp.drawModal.cost')}:</Text>
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.300">
                    {formatAmount(getTotalCost())} {pool?.symbol}
                  </Text>
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.400">×</Text>
                  <Badge
                    colorScheme="yellow"
                    fontSize={{ base: "xs", md: "sm" }}
                    px={2}
                    py={1}
                    borderRadius="full"
                    textShadow="0 0 10px rgba(236, 201, 75, 0.5)"
                    boxShadow="0 0 10px rgba(236, 201, 75, 0.2)"
                  >
                    {leverage}x
                  </Badge>
                </HStack>
              </VStack>
            </Box>

            {pool?.token && showTransactions && (
              <Box
                w="100%"
                p={4}
                borderRadius="xl"
                bg="gray.700"
                borderWidth="1px"
                borderColor="blue.500"
                boxShadow="0 0 20px rgba(66, 153, 225, 0.2)"
              >
                <VStack align="stretch" spacing={3}>
                  <Text fontSize={{ base: "sm", md: "md" }} color="white" fontWeight="bold">{t('dapp.drawModal.transactionProgress')}:</Text>
                  {transactionSteps.map((step, index) => (
                    <HStack key={step.id} spacing={3} p={2} bg="gray.800" borderRadius="md">
                      {getStatusIcon(step.status)}
                      <Text
                        fontSize={{ base: "xs", md: "sm" }}
                        color={getStatusColor(step.status)}
                        fontWeight="medium"
                      >
                        {step.label}
                      </Text>
                    </HStack>
                  ))}
                </VStack>
              </Box>
            )}

            {txError && (
              <Alert status="error" bg="red.900" borderRadius="md">
                <AlertIcon />
                <Text fontSize={{ base: "xs", md: "sm" }} color="white">{txError}</Text>
              </Alert>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            color="gray.300"
            mr={3}
            onClick={onClose}
            isDisabled={isSubmitting}
            _hover={{
              bg: 'whiteAlpha.100'
            }}
            size={{ base: "sm", md: "md" }}
          >
            {t('dapp.drawModal.cancel')}
          </Button>
          <Button
            colorScheme="yellow"
            onClick={handleDraw}
            isLoading={isSubmitting}
            loadingText={t('dapp.drawModal.confirming')}
            spinnerPlacement="start"
            leftIcon={isSubmitting ? null : <FaDice />}
            isDisabled={isBalanceInsufficient() || isSubmitting}
            _hover={{
              transform: 'translateY(-2px)',
              boxShadow: '0 0 20px rgba(236, 201, 75, 0.3)',
            }}
            size={{ base: "sm", md: "md" }}
          >
            {isBalanceInsufficient() ? t('dapp.drawModal.insufficientBalance') : t('dapp.drawModal.draw')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function WalletInfo({ account, chainId, onDisconnect, onSwitchChain, onSwitchWallet }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = React.useRef();
  const networks = {
    1: { name: 'Ethereum Mainnet', icon: '', color: '#627eea' },
    56: { name: 'BNB Smart Chain', icon: '', color: '#f3ba2f' },
    137: { name: 'Polygon', icon: '', color: '#8247e5' },
    42161: { name: 'Arbitrum One', icon: '', color: '#28a0f0' }
  };

  const currentNetwork = networks[chainId] || {
    name: 'Unknown Network',
    icon: '',
    color: '#666666'
  };

  const formatAddress = (addr) => {
    return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box
      top={{ base: 2, md: 4 }}
      right={{ base: 2, md: 4 }}
      zIndex={100}
      ref={menuRef}
    >
      <Button
        onClick={() => setIsOpen(!isOpen)}
        bg="gray.800"
        color="white"
        borderWidth="1px"
        borderColor="blue.500"
        size={{ base: "sm", md: "md" }}
        px={{ base: 2, md: 4 }}
        _hover={{
          transform: 'translateY(-2px)',
          boxShadow: '0 0 20px rgba(66, 153, 225, 0.3)',
        }}
        rightIcon={
          <Box
            as="span"
            ml={2}
            w={2}
            h={2}
            borderRadius="full"
            bg="green.400"
            boxShadow="0 0 10px rgba(72, 187, 120, 0.5)"
          />
        }
      >
        {formatAddress(account)}
      </Button>

      <Collapse in={isOpen}>
        <Box
          position="absolute"
          right={0}
          mt={2}
          p={4}
          bg="gray.800"
          borderRadius="xl"
          borderWidth="1px"
          borderColor="blue.500"
          boxShadow="xl"
          w={{ base: "280px", md: "300px" }}
        >
          <VStack spacing={4} align="stretch">
            <Box>
              <Text color="gray.400" fontSize="sm">Connected Account</Text>
              <Text color="white" fontSize="md" fontFamily="monospace" wordBreak="break-all">
                {account}
              </Text>
            </Box>

            <Box>
              <Text color="gray.400" fontSize="sm">Network</Text>
              <HStack>
                <Badge
                  px={2}
                  py={1}
                  borderRadius="full"
                  bg={currentNetwork.color}
                  color="white"
                  fontSize="sm"
                >
                  {currentNetwork.icon} {currentNetwork.name}
                </Badge>
              </HStack>
            </Box>

            <Divider borderColor="gray.600" />

            <VStack spacing={2}>
              <Button
                size="sm"
                variant="outline"
                colorScheme="blue"
                onClick={onSwitchChain}
                w="100%"
                leftIcon={<FaExchangeAlt />}
              >
                Switch Network
              </Button>
              <Button
                size="sm"
                variant="outline"
                colorScheme="purple"
                onClick={onSwitchWallet}
                w="100%"
                leftIcon={<FaWallet />}
              >
                Switch Wallet
              </Button>
              <Button
                size="sm"
                variant="outline"
                colorScheme="red"
                onClick={onDisconnect}
                w="100%"
                leftIcon={<FaPowerOff />}
              >
                Disconnect
              </Button>
            </VStack>
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
}

function NetworkSwitchModal({ isOpen, onClose }) {
  const { switchNetwork } = useAppKitNetwork();

  const handleSwitchToPolygon = async () => {
    try {
      await switchNetwork(polygon);
      onClose();
    } catch (error) {
      console.error('Failed to switch network:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Unsupported Network</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Please switch to the Polygon network to use this application.</Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSwitchToPolygon}>
            Switch to Polygon
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
const defaultSelectedPool=localStorage.getItem('selected');
const getWithDefault = (object, key, default_value) => {
  return object[key]===undefined ? default_value : object[key];
}
function AppContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open: connectWalletModal, close } = useAppKit();
  const { address, isConnected, status } = useAppKitAccount();
  const appkitProvider   = useAppKitProvider('eip155');
  console.log('appkitProvider',appkitProvider);
  const { walletProvider,walletProviderType } = appkitProvider;
  const account = address;
  const { disconnect } = useDisconnect();
  const { switchNetwork, chainId } = useAppKitNetwork();
  console.log(account, isConnected, status, chainId);

  const [allBalance, setAllBalance] = useState({});
  const [recentDraws, setRecentDraws] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const chainConfig = config[chainId];

  const [selectedPool, setSelectedPool] = useState(defaultSelectedPool);
  const chainBalance=allBalance[chainId]||{};
  const balance=getWithDefault(chainBalance,selectedPool,'-');
  const [winningCount, setWinningCount] = useState({});
  const updateSelectedPool=(newPool)=>{
    localStorage.setItem('selected', newPool);
    console.log(newPool,localStorage.getItem('selected'));
    setSelectedPool(newPool);
  }
  const toast = useToast();
  const { isOpen: isNetworkModalOpen, onOpen: onNetworkModalOpen, onClose: onNetworkModalClose } = useDisclosure();
  const { isOpen: isDrawModalOpen, onOpen: onDrawModalOpen, onClose: onDrawModalClose } = useDisclosure();
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const pool = chainConfig?.pools.find(pool => pool?.name === selectedPool);
  useEffect(() => {
    if (chainConfig && !pool && chainConfig.pools && chainConfig.pools.length) {
      setSelectedPool(chainConfig.pools[0].name);
    }
  }, [chainConfig, pool]);
  useEffect(() => {
    if(walletProviderType && !walletProvider && account && status === 'connected') {
      toast({
        title: t('dapp.walletConnecting'),
        description: t('dapp.autoReconnect'),
        status: 'info',
        duration: 3000,
        isClosable: true,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  },[walletProvider,walletProviderType]);
  // Calculate pagination
  const indexOfLastDraw = currentPage * itemsPerPage;
  const indexOfFirstDraw = indexOfLastDraw - itemsPerPage;
  const currentDraws = recentDraws.slice(indexOfFirstDraw, indexOfLastDraw);
  const totalPages = Math.ceil(recentDraws.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const updateBalance = async () => {
    if (account && pool && account!=="undefined") {
      if (pool?.native) {
        const balance = await chainConfig.provider.getBalance(account);
        chainBalance[selectedPool]=convertTokenAmt(balance, pool);
        setAllBalance({ 
          ...allBalance,
          [chainId]:chainBalance
      });
      } else {
        //ERC balance
        let ercContract = new ethers.Contract(
          pool.token,
          ERCABI,
          chainConfig.provider
        );
        const balance = await ercContract.balanceOf(account);
        chainBalance[selectedPool]=convertTokenAmt(balance, pool);
        setAllBalance({ 
          ...allBalance,
          [chainId]:chainBalance
      });
      }
    }

  };
  
  const handleDrawConfirm = async ({ numbers, ticketCount, leverage, txHash, timestamp }) => {
    if (pool && walletProvider) {
      const draws = [{
        pool: selectedPool,
        time: `${format_date(timestamp)}`,
        timestamp: timestamp,
        amount: ticketCount * pool?.ticketPrice,
        leverage: `${leverage}x`,
        memo: numbers.join(','),
        win: false,
        txHash: txHash
      }, ...recentDraws];
      setRecentDraws(draws);
      localStorage.setItem('recentDraws_' + account, JSON.stringify(draws, (key, value) =>
        typeof value === 'bigint'
          ? value.toString()
          : value // return everything else unchanged
      ));
      toast({
        title: t('dapp.drawSuccess'),
        description: t('dapp.lotteryDrawProcessed').replace('{pool}', selectedPool),
        status: 'success',
        duration: 6000,
        isClosable: true,
      });
      updateBalance();
      fetchRecentDraws();
      onDrawModalClose();
    }
  };

  const fetchRecentDraws = async () => {
    const draws = JSON.parse(localStorage.getItem('recentDraws_' + account) || '[]');
    draws.sort((a, b) => b.timestamp - a.timestamp);
    setRecentDraws(draws);
    console.log('pool and account', pool, account, draws);
    if (pool && account && account!=="undefined") {
      try {
        let contract = new ethers.Contract(
          pool?.address,
          NativeBitBitWin.abi,
          chainConfig.provider
        );
        const newWinningCount = await contract.getUserWinningDrawCount(account);
        const currentWinningCount=winningCount[pool?.name];
        console.log('newWinningCount', newWinningCount,currentWinningCount);
        if (newWinningCount !== currentWinningCount) {
          const winningDraws = await contract.getUserWinningDraws(account);
          if (winningDraws.length) {
            console.log('winning_draws', winningDraws);
            const drawMapping = draws.reduce((acc, draw) => {
              acc[draw.timestamp + '_' + draw.memo] = draw;
              return acc;
            }, {})
            winningDraws.forEach(draw => {
              const id = draw.timestamp + '_' + draw.memo;
              if (drawMapping[id]) {
                console.log('drawMapping[id]', drawMapping[id]);
                drawMapping[id].win = true;
              } else {
                const copy = {};
                copy.win = true;
                copy.pool = pool?.name;
                copy.time = format_date(draw.timestamp);
                copy.memo = draw.memo;
                copy.timestamp = Number(draw.timestamp);
                copy.leverage = `${draw.leverage}x`;
                copy.amount = convertTokenAmt(draw.amount, pool);
                draws.push(copy);
              }
            });
            draws.sort((a, b) => b.timestamp - a.timestamp);
            const drawsL = [...draws];
            setRecentDraws(drawsL);
            setWinningCount({...winningCount, [pool?.name]:newWinningCount});
            localStorage.setItem('recentDraws_' + account, JSON.stringify(drawsL));
          }
        }

      } catch (error) {
        console.error('Error fetching recent draws:', error);
      }
    }
  };
  useEffect(() => {
    fetchRecentDraws();
    updateBalance();
  }, [chainId, account, selectedPool, pool]);

  const handleSwitchChain = async () => {
    try {
      const networks = [
        polygon,
        mainnet
      ];

      const currentIndex = networks.findIndex(n => n.id === chainId);
      const nextNetwork = networks[(currentIndex + 1) % networks.length];
      console.log('currentIndex', currentIndex, 'nextNetwork', nextNetwork);
      await switchNetwork(nextNetwork);

      toast({
        title: t('dapp.networkChanged'),
        description: t('dapp.switchedTo').replace('{network}', nextNetwork.name),
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: t('dapp.errorSwitchingNetwork'),
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };


  useEffect(() => {
    if (isConnected && !chainConfig) {
      onNetworkModalOpen();
    }
  }, [isConnected, chainConfig, onNetworkModalOpen]);

  return (
    <Box textAlign="center" fontSize="xl" bg="gray.900" minH="100vh" color="white" position="relative">
      {account && (
        <Box position="fixed" top="0" right="0" p="4" zIndex="100">
          <HStack spacing={4} alignItems="center" justify="flex-end">
            <LanguageSelector />
            <WalletInfo
              account={account}
              chainId={chainId}
              onDisconnect={disconnect}
              onSwitchChain={handleSwitchChain}
              onSwitchWallet={connectWalletModal}
            />
          </HStack>
        </Box>
      )}
      <Container maxW="container.xl" py={{ base: 16, md: 10 }}>
        <VStack spacing={8}>
          <Heading
            as="h1"
            size="2xl"
            bgGradient="linear(to-r, cyan.400, blue.500, purple.600)"
            bgClip="text"
            fontWeight="extrabold"
            cursor="pointer"
            onClick={() => navigate('/')}
            _hover={{
              opacity: 0.8,
              transform: 'scale(1.02)',
            }}
            transition="all 0.2s"
          >
            BitBitWin
          </Heading>

          {!account ? (
            <Button
              leftIcon={<FaWallet />}
              colorScheme="blue"
              size="lg"
              onClick={connectWalletModal}
              variant="outline"
              _hover={{
                bg: 'blue.800',
                transform: 'translateY(-2px)',
                boxShadow: 'lg',
              }}
            >
              {t('dapp.connectWallet')}
            </Button>
          ) : (
            <Grid templateColumns="repeat(1, 1fr)" gap={6} width="100%">
              <PoolSelector
                chainConfig={chainConfig}
                selectedPool={selectedPool}
                onPoolSelect={updateSelectedPool}
              />

              <Box
                p={6}
                borderRadius="xl"
                bg="gray.800"
                borderWidth="1px"
                borderColor="blue.500"
                boxShadow="0 0 20px rgba(66, 153, 225, 0.3)"
              >
                <StatGroup>
                  <Stat>
                    <StatLabel fontSize="md">{t('dapp.yourBalance')}</StatLabel>
                    <StatNumber
                      fontSize="3xl"
                      bgGradient="linear(to-r, cyan.400, blue.500)"
                      bgClip="text"
                    >
                      {balance} {selectedPool}
                    </StatNumber>
                  </Stat>
                </StatGroup>
              </Box>

              <Button
                leftIcon={<FaDice />}
                colorScheme="purple"
                size="lg"
                onClick={onDrawModalOpen}
                width="100%"
                _hover={{
                  transform: 'translateY(-2px)',
                  boxShadow: '0 0 20px rgba(159, 122, 234, 0.3)',
                }}
              >
                {t('dapp.drawLottery').replace('{pool}', selectedPool)}
              </Button>

              <Box
                p={6}
                borderRadius="xl"
                bg="gray.800"
                borderWidth="1px"
                borderColor="purple.500"
                overflowX="auto"
              >
                <Heading size="md" mb={4}>
                  <FaHistory /> {t('dapp.recentDraws').replace('{pool}', selectedPool)}
                </Heading>
                <TableContainer>
                  <Table variant="simple" size={isMobile ? "sm" : "md"}>
                    <Thead>
                      <Tr>
                        <Th color="gray.400">{t('dapp.time')}</Th>
                        <Th color="gray.400" isNumeric>{t('dapp.amount')}</Th>
                        <Th color="gray.400">{t('dapp.multiplier')}</Th>
                        <Th color="gray.400" display={{ base: 'none', md: 'table-cell' }}>{t('dapp.memo')}</Th>
                        <Th color="gray.400">{t('dapp.result')}</Th>
                        <Th color="gray.400">{t('dapp.tx')}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {currentDraws.map((draw, index) => (
                        <Tr
                          key={index}
                          bg={draw.win ? 'green.900' : 'transparent'}
                          _hover={{
                            bg: draw.win ? 'green.800' : 'whiteAlpha.100'
                          }}
                        >
                          <Td fontSize={isMobile ? "xs" : "sm"}>
                            {isMobile ? format_mobile_date(draw.timestamp) : draw.time}
                          </Td>
                          <Td isNumeric fontSize={isMobile ? "xs" : "sm"}>
                            <Text color={draw.win ? 'green.300' : 'gray.400'}>
                              {draw.amount} {draw.pool}
                            </Text>
                          </Td>
                          <Td fontSize={isMobile ? "xs" : "sm"}>
                            <Badge
                              colorScheme="yellow"
                              variant="solid"
                              fontSize={isMobile ? "2xs" : "xs"}
                              px={2}
                              py={1}
                              borderRadius="full"
                              textShadow="0 0 10px rgba(236, 201, 75, 0.5)"
                              boxShadow="0 0 10px rgba(236, 201, 75, 0.2)"
                            >
                              {draw.leverage}
                            </Badge>
                          </Td>
                          <Td display={{ base: 'none', md: 'table-cell' }} fontSize={isMobile ? "xs" : "sm"}>
                            {draw.memo}
                          </Td>
                          <Td>
                            <Badge
                              colorScheme={draw.win ? 'green' : 'red'}
                              fontSize={isMobile ? "2xs" : "xs"}
                              px={2}
                              py={1}
                              borderRadius="full"
                            >
                              {draw.win ? t('dapp.win') : t('dapp.loss')}
                            </Badge>
                          </Td>
                          <Td>
                            {draw.txHash && (
                              <IconButton
                                aria-label="View transaction"
                                icon={<Icon as={FaExchangeAlt} />}
                                size="sm"
                                variant="ghost"
                                colorScheme="blue"
                                isDisabled={!chainConfig}
                                onClick={() => {
                                  if (!chainConfig) return;
                                  const url = chainConfig.getTransactionUrl(draw.txHash);
                                  window.open(url, '_blank');
                                }}
                              />
                            )}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>

                <HStack spacing={2} justify="center" mt={4}>
                  <Button
                    size="sm"
                    variant="outline"
                    colorScheme="blue"
                    onClick={() => handlePageChange(currentPage - 1)}
                    isDisabled={currentPage === 1}
                  >
                    {t('dapp.previous')}
                  </Button>
                  {[...Array(totalPages)].map((_, index) => (
                    <Button
                      key={index}
                      size="sm"
                      variant={currentPage === index + 1 ? "solid" : "outline"}
                      colorScheme="blue"
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </Button>
                  ))}
                  <Button
                    size="sm"
                    variant="outline"
                    colorScheme="blue"
                    onClick={() => handlePageChange(currentPage + 1)}
                    isDisabled={currentPage === totalPages}
                  >
                    {t('dapp.next')}
                  </Button>
                </HStack>
              </Box>

              <DrawModal
                isOpen={isDrawModalOpen}
                onClose={onDrawModalClose}
                onConfirm={handleDrawConfirm}
                pool={pool}
                balance={balance}
                walletProvider={walletProvider}
                account={account}
                chainConfig={chainConfig}
              />
            </Grid>
          )}
        </VStack>
      </Container>
      <NetworkSwitchModal isOpen={isNetworkModalOpen} onClose={onNetworkModalClose} />
      {pool && (
        <DrawModal
          isOpen={isDrawModalOpen}
          onClose={onDrawModalClose}
          onConfirm={handleDrawConfirm}
          pool={pool}
          balance={balance}
          walletProvider={walletProvider}
          account={account}
          chainConfig={chainConfig}
        />
      )}
    </Box>
  );
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<AppContent />} />
        <Route path="/pool" element={<PoolPage />} />
        <Route path="/doc" element={<DocPage />} />
      </Routes>
    </ChakraProvider>
  );
}

export { WalletInfo, PoolSelector, convertTokenAmt, parseTokenAmt };
export default App;
